// Web stub for react-native-fast-image -> renders RNW Image
import React from 'react'
import { Image } from 'react-native-web'

const FastImage = React.forwardRef((props, ref) => {
  const { source, ...rest } = props
  // FastImage source may be { uri } | number(url via webpack) | require() string
  return <Image ref={ref} source={source} {...rest} />
})

FastImage.resizeMode = {
  contain: 'contain',
  cover: 'cover',
  stretch: 'stretch',
  center: 'center',
}
FastImage.priority = { low: 'low', normal: 'normal', high: 'high' }
FastImage.cacheControl = {
  immutable: 'immutable',
  web: 'web',
  cacheOnly: 'cacheOnly',
}
FastImage.preload = () => {}
FastImage.clearMemoryCache = async () => {}
FastImage.clearDiskCache = async () => {}

export default FastImage
